<template>
  <div class="form-card">
    <div class="form-card__header">
      <h6 class="form-card__title">
        <i class="bi bi-credit-card"></i>
        Medios de Pago
      </h6>
    </div>
    <div class="form-card__body">
      <div class="d-flex flex-column">
        <label class="d-inline-flex align-items-center mb-1">
          <input type="checkbox" class="mr-2" checked disabled>
          Efectivo
        </label>
        <label class="d-inline-flex align-items-center mb-1">
          <input v-model="newbo_paymentmethods.cuenta_corriente" type="checkbox" class="mr-2">
          Cuenta Corriente
        </label>
        <label class="d-inline-flex align-items-center mb-1">
          <input v-model="newbo_paymentmethods.cheques" type="checkbox" class="mr-2">
          Cheques
        </label>
        <label class="d-inline-flex align-items-center mb-1">
          <input v-model="newbo_paymentmethods.tarjetas" type="checkbox" class="mr-2">
          Tarjetas
        </label>
      </div>
      <a v-if="newbo_paymentmethods.tarjetas" href="/configuracion/tarjetas" class="form-card__btn form-card__btn--primary d-inline-flex mt-2">
        Tarjetas
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: ['bo_paymentmethods'],
  data: function() {
    return {
      newbo_paymentmethods: {}
    }
  },
  mounted: function () {
    this.newbo_paymentmethods = this.bo_paymentmethods;
  },
  methods: {

  }
}
</script>
